<template>

    <div class="loader" :class="classes" :style="styles" />

</template>

<style scoped lang="scss">

    @import "@sass/_variables.scss";

    .loader {
        background: transparent;
        animation: spin .4s linear infinite;
        border: 2px solid transparent;
        border-radius: 50%;
        border-left: 2px solid $color-text;
        border-top: 2px solid $color-text;
    }

    .loader-centered {
        margin: 60px auto;
    }

    .loader-dark {
        border-left-color: $color-text;
        border-top-color: $color-text;
    }
    .loader-light {
        border-left-color: $color-white;
        border-top-color: $color-white;
    }

    .loader-12, .loader-xs {
        height: 12px;
        width: 12px;
    }
    .loader-16, .loader-sm {
        height: 16px;
        width: 16px;
    }
    .loader-20, .loader-md {
        height: 20px;
        width: 20px;
    }
    .loader-30, .loader-lg {
        height: 30px;
        width: 30px;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

</style>

<script>

export default {

    props: {
        size: {
            type: String,
            default: 'md',
        },
        theme: {
            type: String,
            default: 'dark',
        },
        color: {
            type: String,
        },
        centered: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        classes() {
            return {
                'loader-xs': this.size === 'xs',
                'loader-sm': this.size === 'sm',
                'loader-md': this.size === 'md',
                'loader-lg': this.size === 'lg',
                'loader-light': this.theme === 'light',
                'loader-dark': this.theme === 'dark',
                'loader-centered': this.centered,
            };
        },

        styles() {
            if (this.color) {
                return {
                    'border-left-color': this.color,
                    'border-top-color': this.color,
                }
            } else {
                return {};
            }
        },

    },

}

</script>